export const PAYMENT_REDIRECT_STATUS_KEY = "redirect_status";

export const PAYMENT_REDIRECT_METHOD_KEY = "payment_method";
